import React from 'react';
import ReactDOM from 'react-dom';
import { Root } from './components';

// render app
ReactDOM.render(<Root />, document.getElementById('app'));
